export const RETRYABLE_STATUS = 503;
export const TOO_LARGE_STATUS = 413;

const STATUS_FALLBACK = {
  400: "Please check the details you entered and try again.",
  401: "Your session has expired. Please sign in again.",
  403: "You don't have permission to do that.",
  404: "We couldn't find what you were looking for.",
  409: "That conflicts with something that already exists.",
  413: "The request is too large. Please use a smaller file.",
  503: "That service is temporarily unavailable. Please try again in a moment.",
};

const GENERIC = "Something went wrong please try again!";

const NEWLINE = String.fromCharCode(10);

export const extractApiErrorCode = (data) => {
  const err = data?.Error ?? data?.error;
  if (err && typeof err === "object") {
    return err.ErrorCode ?? err.errorCode ?? null;
  }
  return null;
};

export const extractApiErrorMessage = (data, status) => {
  const err = data?.Error ?? data?.error;

  if (typeof err === "string" && err.trim()) {
    return err.trim();
  }

  if (err && typeof err === "object") {
    const message = err.ErrorMessage ?? err.errorMessage;
    if (typeof message === "string" && message.trim()) {
      return message.trim();
    }
  }

  const everify = Array.isArray(data?.errors) ? data.errors : null;
  if (everify?.length) {
    const messages = everify
      .map((e) => e?.message)
      .filter((m) => typeof m === "string" && m.trim());
    if (messages.length) {
      return messages.join(NEWLINE);
    }
  }

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  return STATUS_FALLBACK[status] || GENERIC;
};

export const isRetryableApiError = (status) => status === RETRYABLE_STATUS;

export const splitApiErrorLines = (message) =>
  typeof message === "string"
    ? message.split(NEWLINE).map((line) => line.trim()).filter(Boolean)
    : [];
